
import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchData = () => ({
  type: types.FETCH_DATA,
});

const setFetching = (flag) => ({
  type: types.FETCHING,
  flag
});

const setError = (flag) => ({
  type: types.SET_ERROR,
  flag
});

const showActiveAlerts = (flag) => ({
  type: types.SHOW_ACTIVE_ALERTS,
  flag
});

const setSummaryData = (payload) => ({
  type: types.SET_SUMMARY_DATA,
  payload
});

const setSearchKey = (tabKey) => ({
  type: types.SET_SEARCH_KEY,
  payload: tabKey,
});

const setSelectedTab = (tabKey) => ({
  type: types.SET_SELECTED_TAB,
  payload: tabKey,
});

const selectSeverity = (payload) => ({
  type: types.SELECT_SEVERITY,
  payload,
})

const unSelectSeverity = (payload) => ({
  type: types.UN_SELECT_SEVERITY,
  payload,
})

const selectMetric = (payload) => ({
  type: types.SELECT_METRIC,
  payload,
})

const unSelectMetric = (payload) => ({
  type: types.UN_SELECT_METRIC,
  payload,
})

const setFilter = (filter) => ({
  type: types.SET_FILTER,
  filter,
})

const resetMetricSelection = () => ({
  type: types.RESET_METRIC_SELECTION,
})

const resetSeveritySelection = () => ({
  type: types.RESET_TAB_SELECTION,
})

const setAiAlertsSummaryTableData = (tableData) => ({
  type: types.SET_AI_ALERTS_SUMMARY_TABLE_DATA,
  tableData
})

const setSummaryTableSort = (sortObj) => ({
  type: types.SET_AI_ALERTS_SUMMARY_TABLE_SORT,
  sortObj
})

export {
  init,
  fetching,
  fetchData,
  setSearchKey,
  setSelectedTab,
  setFetching,
  setError,
  selectSeverity,
  unSelectSeverity,
  selectMetric,
  unSelectMetric,
  setSummaryData,
  setFilter,
  resetMetricSelection,
  resetSeveritySelection,
  showActiveAlerts,
  setAiAlertsSummaryTableData,
  setSummaryTableSort
}
